import { useMutation } from '@tanstack/react-query';
import { ApiClient, apiPaths, useApiErrorStoreActions } from '@repo/api/client';
import { postTokenCreateBodyResponseSchema } from './token.schema';
var apiEndpoint = apiPaths.token.create;
function postTokenCreate(_a) {
    var payload = _a.payload;
    return ApiClient.fetch(apiEndpoint.path, {
        options: { method: 'POST', body: JSON.stringify(payload) },
        successSchema: postTokenCreateBodyResponseSchema,
    });
}
export function usePostTokenCreate() {
    var setApiError = useApiErrorStoreActions().setApiError;
    return useMutation({
        retry: false,
        mutationFn: postTokenCreate,
        onError: function (error) {
            setApiError({
                apiPathId: apiEndpoint.id,
                error: error,
            });
        },
    });
}
